import { USER_LOGGED_OUT } from '../constants/user';
import {
    CHANGE_SUBMISSION,
    CHANGE_SUBMISSION_COVERAGE,
    CHANGE_SUBMISSION_DIALOG_STATUS,
    CHANGE_SUBMISSION_RELATED_ENTITIES,
    CHANGE_SUBMISSION_STATUS,
    CLEAR_AND_CHANGE_SUBMISSION,
    CLEAR_SUBMISSION,
    CREATE_RELATED_SUBMISSION,
    EDIT_SUBMISSION,
    FETCH_SUBMISSIONS,
    GET_SUBMISSION,
    INITIAL_SUBMISSION_STATE,
    SET_SUBMISSION_AND_DIALOG_STATUS,
    SET_SUBMISSION_DIALOG_STATUS,
    SUBMISSION_CLEARANCE_FAILED,
    SUBMISSION_CLEARANCE_PASSED,
    SUBMISSION_CLEARANCE_PENDING,
    SUBMISSION_CREATE,
    SUBMISSION_CREATE_FAILED,
    SUBMISSION_CREATE_SUCCESS,
    SUBMISSION_EDIT,
    SUBMISSION_EDIT_FAILED,
    SUBMISSION_EDIT_SUCCESS,
    SUBMISSION_EXCESS_SELECTION,
    SUBMISSION_FAILED,
    SUBMISSION_KNOCKED_OUT,
    SUBMISSION_QUOTED,
    SUBMISSION_STATUS,
    SUBMISSION_SUBMIT_FOR_REVIEW,
    SUBMIT_SUBMISSION_QUOTE,
    FETCH_PRE_CLEARED_SUBMISSION,
    SUBMISSION_CHANGE_PRICING_VALUE,
    SUBMISSION_LIMIT_CHANGE,
    SUBMISSION_ADJUSTED_COMMISSION_CHANGE,
    SUBMISSION_UPDATE,
    SUBMISSIONS_REFETCH,
    DOWNLOAD_SUBMISSION_QUOTE,
    SUBMISSION_UPDATE_WORKFLOW_STATUS_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_LIMIT_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_COVERAGE_CHANGE,
    SUBMISSION_UPDATE_WORKFLOW_INCLUDED_CHANGE,
    UNLOCK_BIND,
    LOCK_BIND,
    DOWNLOAD_SUBMISSION_REVISION_QUOTE,
    SUBMISSION_UPDATE_BIND_STATUS_CHANGE,
    SUBMISSION_SET_ISBINDED,
    CHANGE_AI_FORMS,
    CHANGE_AI_LIST,
    SUBMISSION_SET_ISBINDERSAVED,
    DOWNLOAD_SUBMISSION_QUOTE_SPECIMEN,
    GET_PDF_ARRAY,
    SUBMISSION_UPDATE_RATING_OPTION,
    SUBMISSION_UPDATE_ADDL_DOCS_ID,
    SUBMISSION_UPDATE_IS_EXCESS_ONLY,
    SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS_FOR_ID,
    SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS,
    SUBMISSION_UPDATE_BY_KEY,
    LOAD_ARGOPI,
    LOAD_ARGOPI_SUCCESS,
    LOAD_ARGOPI_FAILURE,
    LOAD_ARGOPI_RESET
} from './../constants/submission';

// note on action generators - if possible, try to make
// state change action creators explicit as
// it makes for an easier time reasoning about the actions in redux
export const submissionClearancePassed = submissionType => {
    return {
        type: SUBMISSION_CLEARANCE_PASSED,
        value: {
            submissionType
        }
    };
};

export const setSubmissionDialogStatus = status => {
    return {
        type: SET_SUBMISSION_DIALOG_STATUS,
        value: status
    };
};
export const changeSubmissionDialogStatus = status => {
    return {
        type: CHANGE_SUBMISSION_DIALOG_STATUS,
        value: status
    };
};

export const submitSubmissionQuote = (submission, dialogStatus) => {
    return {
        type: SUBMIT_SUBMISSION_QUOTE,
        value: {
            submission,
            dialogStatus
        }
    };
};
// SET_DIALOG_STATUS
export const setInitialSubmissionState = () => {
    return {
        type: INITIAL_SUBMISSION_STATE
    };
};

export const setSubmissionAndDialogStatus = () => {
    return {
        type: SET_SUBMISSION_AND_DIALOG_STATUS
    };
};
export const submissionClearanceFailed = (submissionType, matches) => {
    return {
        type: SUBMISSION_CLEARANCE_FAILED,
        value: {
            submissionType,
            matches
        }
    };
};

export const submissionClearancePending = (submissionType, matches) => {
    return {
        type: SUBMISSION_CLEARANCE_PENDING,
        value: {
            submissionType,
            matches
        }
    };
};

export const submissionQuoted = submissionInfo => {
    return {
        type: SUBMISSION_QUOTED,
        value: submissionInfo
    };
};

export const submissionKnockedOut = submissionInfo => {
    return {
        type: SUBMISSION_KNOCKED_OUT,
        value: submissionInfo
    };
};

export const submissionFailed = submissionInfo => {
    return {
        type: SUBMISSION_FAILED,
        value: submissionInfo
    };
};

export const submissionCreate = submissionInfo => {
    return {
        type: SUBMISSION_CREATE,
        value: submissionInfo
    };
};

export const submissionCreateFailed = error => {
    return {
        type: SUBMISSION_CREATE_FAILED,
        value: error
    };
};

export const submissionCreateSuccess = submission => {
    return {
        type: SUBMISSION_CREATE_SUCCESS,
        value: submission
    };
};

export const submissionEdit = submission => {
    return {
        type: SUBMISSION_EDIT,
        value: submission
    };
};

export const submissionEditFailed = error => {
    return {
        type: SUBMISSION_EDIT_FAILED,
        value: error
    };
};

export const submissionEditSuccess = payload => {
    return {
        type: SUBMISSION_EDIT_SUCCESS,
        value: payload
    };
};

export const changeSubmissionStatus = status => {
    return {
        type: CHANGE_SUBMISSION_STATUS,
        status
    };
};

export const clearSubmissionStatus = () => {
    return {
        type: CLEAR_AND_CHANGE_SUBMISSION
    };
};
export const clearSubmission = () => {
    return {
        type: CLEAR_SUBMISSION
    };
};

export const changeSubmissionNone = () => {
    return {
        type: CHANGE_SUBMISSION_STATUS,
        status: SUBMISSION_STATUS.NONE
    };
};

export const submissionSubmitForReview = (submission, dialogStatus) => {
    return {
        type: SUBMISSION_SUBMIT_FOR_REVIEW,
        payload: {
            submission,
            dialogStatus
        }
    };
};

export const changeSubmission = (submission, submissionFormParams) => {
    return {
        type: CHANGE_SUBMISSION,
        payload: {
            submission,
            submissionFormParams
        }
    };
};
export const excessQuoteSelection = excessChecked => {
    return {
        type: SUBMISSION_EXCESS_SELECTION,
        value: excessChecked
    };
};

export const changeRelatedEntities = edgeNumber => {
    return {
        type: CHANGE_SUBMISSION_RELATED_ENTITIES,
        value: edgeNumber
    };
};

export function getSubmissions(user) {
    const brokerId = user.role.startsWith('broker') ? user.brokerId : '';
    const body = { brokerId };
    return {
        type: GET_SUBMISSION,
        payload: { body, user }
    };
}

export function fetchSubmissions(data) {
    return { type: FETCH_SUBMISSIONS, payload: data };
}

export function editSubmission(submission, user) {
    return { type: EDIT_SUBMISSION, payload: { submission, user } };
}
export const changeCoverage = ({
    submission,
    selectionType,
    selectionAction,
    selectedValue
}) => dispatch => {
    dispatch({
        type: CHANGE_SUBMISSION_COVERAGE,
        value: { submission, selectionType, selectionAction, selectedValue }
    });
};
export function userLogout() {
    return { type: USER_LOGGED_OUT };
}

export function createRelatedSubmission(submission, user) {
    return { type: CREATE_RELATED_SUBMISSION, payload: { submission, user } };
}

export const createPreClearedSubmission = submission => {
    return { type: FETCH_PRE_CLEARED_SUBMISSION, value: { submission } };
};

export const changePricingValue = (keyValue) => {
    return {
        type: SUBMISSION_CHANGE_PRICING_VALUE,
        payload: { ...keyValue }
    }
}
export const limitChange = selectedValue => {
    return {
        type: SUBMISSION_LIMIT_CHANGE,
        value: selectedValue
    };
};

export const adjustedCommissionChange = (adjustedCommission, totalAdjustedCommission) => {
    return {
        type: SUBMISSION_ADJUSTED_COMMISSION_CHANGE,
        value: { adjustedCommission, totalAdjustedCommission }
    };
};
export const updateSubmission = (id, submission, user, refetchSubmissions) => {
    return {
        type: SUBMISSION_UPDATE,
        payload: { id, submission, user, refetchSubmissions }
    }
}

export const unlockBind = (id, submission, user, refetchSubmissions) => {
    return {
        type: UNLOCK_BIND,
        payload: { id, submission, user, refetchSubmissions }
    }
}

export const getPDFArray = (data, pdfStatus) => {
    return {
        type: GET_PDF_ARRAY,
        payload: { data, pdfStatus }
    }
}

export const lockBind = (id, isBinded, isBinderSaved = false) => {
    return {
        type: LOCK_BIND,
        payload: { id, isBinded, isBinderSaved }
    }
}

export const refetchSubmissions = (refetchSubmissions) => {
    return {
        type: SUBMISSIONS_REFETCH,
        payload: { refetchSubmissions }
    }
}

export const downloadQuoteSubmission = (user, submissionID, flag = true) => {
    return { type: DOWNLOAD_SUBMISSION_QUOTE, value: { user, submissionID, flag } };
}

export const downloadQuoteSpecimenSubmission = (user, submissionID, flag = true, isDeductibleSpecimen = false) => {
    return { type: DOWNLOAD_SUBMISSION_QUOTE_SPECIMEN, value: { user, submissionID, flag, isDeductibleSpecimen } };
}

export const downloadQuoteRevisionSubmission = (user, submissionID, revisionNumber, flag = true) => {
    return { type: DOWNLOAD_SUBMISSION_REVISION_QUOTE, value: { user, submissionID, revisionNumber, flag } };
}

export const updateWorkflowStatusChange = (updatedSubmission) => {
    return {
type: SUBMISSION_UPDATE_WORKFLOW_STATUS_CHANGE,
payload: updatedSubmission
    }
}

export const updatedIsBinded = (updatedSubmission) => {
    return {
        type: SUBMISSION_SET_ISBINDED,
        payload: updatedSubmission
    }
}

export const updatedIsBinderSaved = (updatedSubmission) => {
    return {
        type: SUBMISSION_SET_ISBINDERSAVED,
        payload: updatedSubmission
    }
}

export const updateBindStatusChange = (updatedSubmission) => {
    return {
        type: SUBMISSION_UPDATE_BIND_STATUS_CHANGE,
        payload: updatedSubmission
    }
}

export const updateWorkflowLimitChange = (updatedSubmission) => {
    return {
        type: SUBMISSION_UPDATE_WORKFLOW_LIMIT_CHANGE,
        value: updatedSubmission
    }
}

export const updateWorkflowCoverageChange = (updatedSubmission) => {
    return {
        type: SUBMISSION_UPDATE_WORKFLOW_COVERAGE_CHANGE,
        value: updatedSubmission
    }
}

export const updateWorkflowIncludedChange = (updatedSubmission) => {
    return {
        type: SUBMISSION_UPDATE_WORKFLOW_INCLUDED_CHANGE,
        value: updatedSubmission
    }
}

export const changeAIFormValues = (additionalInsuredArray, index, formValues, numberOfAIForms) => {
    return {
        type: CHANGE_AI_FORMS,
        payload: { additionalInsuredArray, index, formValues, numberOfAIForms }
    }

  }

  export const changeAIList = (additionalInsuredArray, numberOfInsureds) => {
    return {
        type: CHANGE_AI_LIST,
        payload: { additionalInsuredArray, numberOfInsureds}
    }

  }

export const updateSubmissionRatingOptions = (data) => {
    return {
        type: SUBMISSION_UPDATE_RATING_OPTION,
        payload: data
    };
}

export const setAdditionalDocumentsId = (additionalDocumentsId) => {
    return {
        type: SUBMISSION_UPDATE_ADDL_DOCS_ID,
        payload: additionalDocumentsId
    };
};

export const setIsExcessOnly= (value) => {
    return {
        type: SUBMISSION_UPDATE_IS_EXCESS_ONLY,
        payload: value
    };
};
export const updateManualQuoteStatusForId = (id, status) => {
    return {
        type: SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS_FOR_ID,
        payload: {
            id,
            status
        }
    }
}

export const updateManualQuoteStatus = (id, dataForUpdate, user, refetchSubmissions) => {
    return {
        type: SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS,
        payload: {
            id,
            dataForUpdate,
            user,
            refetchSubmissions
        }
    }
}

// payload should be object with key and value properties.
export const updateSubmissionByKey = (payload) => {
    return {
        type: SUBMISSION_UPDATE_BY_KEY,
        payload: payload
    };
};

export const loadArgopi = (payload) => {
    return {
        type: LOAD_ARGOPI,
        payload: payload
    }
}

export const loadArgopiFailure = (payload) => {
    return {
        type: LOAD_ARGOPI_FAILURE,
        payload: payload
    }
}

export const loadArgopiSuccess = (payload) => {
    return {
        type: LOAD_ARGOPI_SUCCESS,
        payload: payload
    }
}
export const loadArgopiReset = () => {
    return {
        type: LOAD_ARGOPI_RESET,
        payload: ''
    }
}
